import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import { useWizardDispatch } from '../WizardContext';
import { BACK_STEP, NAVIGATION_ENUM } from '../constants';
import NextButtonContext from './NextButton';
import SubmitButton from './SubmitButton';

export const NavButton = ({
  name, btnClassName, color, variant, type, handler, loading, ...props
}) => {
  const { values } = useFormikContext();
  const dispatch = useWizardDispatch();

  const handleBack = () => dispatch({ type: BACK_STEP, payload: values });

  return (
    <>
      { handler === NAVIGATION_ENUM.NEXT && (
        <NextButtonContext>
          {(handleOnNext) => (
            <Button
              type={type}
              color={color}
              variant={variant}
              className={btnClassName}
              onClick={handleOnNext}
              {...props}
            >
              { name }
            </Button>
          )}
        </NextButtonContext>
      )}
      { handler === NAVIGATION_ENUM.BACK && (
      <Button
        type={type}
        color={color}
        variant={variant}
        className={btnClassName}
        onClick={() => handleBack()}
        {...props}
      >
        { name }
      </Button>
      )}
      { handler === NAVIGATION_ENUM.SUBMIT && (
        <SubmitButton>
          {(handleOnClick) => (
            <Button
              type={type}
              color={color}
              variant={variant}
              disabled={loading}
              className={btnClassName}
              onClick={handleOnClick}
              {...props}
            >
              { loading ? (
                <Container>
                  <CircularProgress
                    size='auto'
                    className='loader'
                    sx={{
                      position: 'relative',
                    }}
                  />
                </Container>
              ) : name }
            </Button>
          )}
        </SubmitButton>
      )}
    </>
  );
};

NavButton.propTypes = {
  name: PropTypes.string.isRequired,
  btnClassName: PropTypes.string,
  handler: PropTypes.string.isRequired,
  color: PropTypes.string,
  variant: PropTypes.string,
  type: PropTypes.string,
  loading: PropTypes.bool,
};

NavButton.defaultProps = {
  btnClassName: undefined,
  color: 'primary',
  variant: 'outlined',
  type: 'button',
  loading: false,
};

export default NavButton;
